import { render, staticRenderFns } from "./FoldersDropdown.vue?vue&type=template&id=23fa7e0b"
import script from "./FoldersDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./FoldersDropdown.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports